export default __webpack_public_path__ + "static/media/bg-1.ed62b2af.jpg";